// CRITICAL FIX: Runtime configuration - NOT compiled at build time!
// This file is imported BEFORE any other modules and cannot be cached incorrectly.

const BACKEND_URL = 'https://classifieds-backend-9uso.onrender.com';

console.log('========================================');
console.log('🚀 RUNTIME CONFIGURATION LOADED');
console.log('   Backend URL:', BACKEND_URL);
console.log('========================================');

export const getBackendApiUrl = () => {
  // With proxy configured, we use the base URL directly
  // The proxy will forward /api/* to port 5000
  console.log('Returning backend API URL:', BACKEND_URL);
  return BACKEND_URL;
};

// Force this to be treated as runtime configuration
export const FORCE_RUNTIME_CONFIG = true;
